<div class="referidos-modal">
  <div class="modal-header">
    <h2>Gestión de referidos</h2>
    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <p>
    ¿<b>{{ data?.nombre }}</b> brindó información sobre referidos?
  </p>

  <div class="opciones">
    <label>
      <input
        type="radio"
        name="referidos"
        [value]="true"
        [(ngModel)]="siSeleccionado"
      />
      <span>SI</span>
    </label>

    <label>
      <input
        type="radio"
        name="referidos"
        [value]="false"
        [(ngModel)]="siSeleccionado"
      />
      <span>NO</span>
    </label>
  </div>

  <div class="observaciones">
    <label>Observaciones:</label>
    <textarea
      id="observaciones"
      name="observaciones"
      [(ngModel)]="observaciones"
      maxlength="200"
      rows="2"
    >
    </textarea>
  </div>

  <button class="guardar-btn" (click)="guardar()" appTrackClick [trackData]="trackData">GUARDAR</button>
</div>